export const categoryList = [
  {
    label: "Tenda",
    value: "Tenda",
    image: "tent.png",
  },
  {
    label: "Panggung",
    value: "Panggung",
    image: "stage.png",
  },
  {
    label: "Kipas/AC",
    value: "Kipas/AC",
    image: "air-conditioning.png",
  },
  {
    label: "Pemiosan",
    value: "Pemiosan",
    image: "gazebo.png",
  },
  {
    label: "Wedding",
    value: "Wedding",
    image: "wedding.png",
  },
  {
    label: "Karpet",
    value: "Karpet",
    image: "carpet.png",
  },
  {
    label: "Sound Sistem",
    value: "Sound Sistem",
    image: "sound-system.png",
  },
  {
    label: "Keramik",
    value: "Keramik",
    image: "ceramic.png",
  },
  {
    label: "Melamin",
    value: "Melamin",
    image: "melamine.png",
  },
  {
    label: "Kain",
    value: "Kain",
    image: "cloth.png",
  },
  {
    label: "Kursi",
    value: "Kursi",
    image: "chair.png",
  },
  {
    label: "Meja",
    value: "Meja",
    image: "table.png",
  },
  {
    label: "TV",
    value: "TV",
    image: "tv.png",
  },
];
